var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurpleAccount(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 48,
    viewBox: "0 0 74 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.4118 21.0002C68.004 22.2287 72 36.728 72 36.728V47.1613H2.00002V27.0733C2.00002 27.0733 6.63342 15.2369 8.0889 13.5256C9.54438 11.8142 12.1593 11.8126 14.7497 11.9684C17.34 12.1241 19.4381 3.87087 21.6123 3.71515C23.7865 3.55943 26.4071 15.7057 28.4749 16.0171C30.5427 16.3285 34.1195 5.73952 36.6831 4.8052C39.2467 3.87087 42.1106 9.63255 44.7904 9.78827C47.4702 9.94399 48.9248 1.8465 51.6866 2.00222C54.4485 2.15794 55.499 18.2082 58.482 21.7788C61.1153 24.9309 62.7168 19.7229 65.4118 21.0002Z",
    fill: "url(#paint0_linear_735_25615)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72 38.007C72 38.007 68.004 22.9737 65.4118 21.6999C62.7168 20.3756 61.1153 25.7754 58.482 22.5072C55.499 18.8051 54.4485 2.16376 51.6866 2.0023C48.9248 1.84084 47.4701 10.2366 44.7904 10.0751C42.1106 9.91364 39.2467 3.93977 36.6831 4.90851C34.1195 5.87724 30.5426 16.8562 28.4749 16.5333C26.4071 16.2104 23.7865 3.61686 21.6123 3.77832C19.4381 3.93977 17.34 12.4969 14.7497 12.3355C12.1593 12.174 9.22359 12.5582 8.08888 13.95C6.95418 15.3419 2 27.9967 2 27.9967",
    stroke: "#AD49E1",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_735_25615",
    x1: 37,
    y1: 2,
    x2: 37,
    y2: 47.1613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5BEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleAccount);
export default __webpack_public_path__ + "static/media/purpleAccount.d750473136213b293f5c2043db8caf58.svg";
export { ForwardRef as ReactComponent };